import React from 'react';

interface IModalContext {
  getModalState: Function;
  setModalState: Function;
}

const context = React.createContext<IModalContext | null>(null);

export default function getUIStateContext() {
  return context;
}
